import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiTab, { TabProps } from "@mui/material/Tab";

const StyledButtonTab = styled(MuiTab)(({ theme }) => ({
  "&.MuiTab-root": {
    backgroundColor: theme.colors.shades[50],
    color: theme.colors.black,
    fontFamily: theme.fonts.bold,
    height: 60,
    fontSize: 14,
    lineHeight: "20px",
    textTransform: "none",
    width: 158,

    [theme.breakpoints.up("md")]: {
      width: 213,
    },

    "&.Mui-selected": {
      backgroundColor: theme.colors.sapphire,
      color: theme.colors.white,
    },
  },
}));

const ButtonTab: FC<TabProps> = (props) => {
  return <StyledButtonTab disableFocusRipple disableRipple {...props} />;
};

export default ButtonTab;
